import {MovieTextLayer} from 'common/src/modules/movie/movieLayers.types';
import {MovieAlign, MovieLayerType} from 'common/src/modules/movie/movie.enums';
import createLayerBase from './createLayerBase';
import createDefaultColor from './createDefaultColor';
import {DPMappingVerticalAlign} from 'common/src/modules/dynamicParameters/dynamicParameters.enums';
import {complexTextDefaultMinFontSize} from 'common/src/modules/complexText/complexText.consts';
import {
  ComplexTextAlign,
  ComplexTextSizeUnit,
  ComplexTextStyle,
} from 'common/src/modules/complexText/complexText.enums';
import {TemplateAsset} from 'common/src/modules/dynamicParameters/dynamicParameters.types';
import {ComplexTextFont} from 'common/src/modules/complexText/complexText.types';

function createTextLayer(font: TemplateAsset['metadata']): MovieTextLayer {
  const textFont: ComplexTextFont = {
    family: font.family || '',
    weight: font.weight?.toString() || '400',
    url: font.url,
    italic: font.italic || false,
  };

  return {
    ty: MovieLayerType.Text,
    i: `1`,
    name: `New Text`,
    ...createLayerBase(),
    text: {
      fontFileUrl: '',
      l: 0,
      lsx: 0,
      fill: createDefaultColor(),
      sof: false,
      pointTextWidth: 0,
      pointTextHeight: 0,
      aeSrcTxt: {
        txt: 'Text Here',
        fontFileName: '',
        fontFamily: textFont.family,
        size: 16,
        fontStyle: textFont.italic ? 'italic' : 'normal',
        justif: MovieAlign.Left,
        verticalAlign: DPMappingVerticalAlign.Top,
        blShift: 0,
        sWidth: 0,
        fColArr: [0, 0, 0],
        sOverF: false,
        trk: 0,
        lead: 19.2,
        allCaps: false,
        smallCaps: false,
        subScr: false,
        supScr: false,
        tsume: 0,
        vScale: 1,
        hScale: 1,
        weight: textFont.weight,
        applyFill: true,
        italic: textFont.italic,
        boxTxtP: {
          x: 0,
          y: 0,
        },
        boxTxtS: {
          w: 0,
          h: 0,
        },
        txtObj: {
          ver: 1,
          allCaps: false,
          wrapText: true,
          globalScale: true,
          verticalAlign: DPMappingVerticalAlign.Top,
          minFontSize: complexTextDefaultMinFontSize,
          fonts: [textFont],
          lines: [
            {
              align: ComplexTextAlign.Left,
              lead: 1.2,
              parts: [
                {
                  color: '#000000',
                  size: 16,
                  sizeUnits: ComplexTextSizeUnit.AbsolutePixels,
                  style: textFont.italic ? ComplexTextStyle.Italic : ComplexTextStyle.Normal,
                  text: 'Text Here',
                  weight: textFont.weight,
                  x_shift: 0,
                  y_shift: 0,
                  letterSpacing: 0,
                  strikeThrough: 0,
                  family: textFont.family,
                },
              ],
            },
          ],
        },
      },
    },
  };
}

export default createTextLayer;
